module.exports = __webpack_public_path__ + "img/device-head.34af2127.png";